import React from "react";
import { Separator } from "../components/ui/separator";
import { useData } from "../components/context/data/DataState";
import ViewChallengeBlock from "../components/user/ViewChallengeBlock";

const AllChallenges = () => {
  const { data, communityId, seasonId } = useData();

  return (
    <div className="p-4 space-y-4">
      {data.community[communityId]?.season[seasonId]?.challenge &&
        Object.values(data.community[communityId]?.season[seasonId]?.challenge).map(
          (item, index) => (
            <React.Fragment key={item.challenge_id}>
              {index > 0 && <Separator className="my-4" />}
              <ViewChallengeBlock item={item} />
            </React.Fragment>
          )
        )}
    </div>
  );
};

export default AllChallenges;
